import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'

import EstateList, {ESTATE_FRAGMENT} from '../EstateList'

import Query from 'components/shared/Query'

const ESTATES_QUERY = gql`
  query Estates($searchQuery: String) {
    viewer {
      id
      broker {
        id
        estateSearch(
          q: $searchQuery,
          first: 100
        ) {
          ...Estate
        }
      }
    }
  }
  ${ESTATE_FRAGMENT}
`

const SearchResult = ({searchQuery}) => {
  return (
    <Query
      inlineError
      inlineLoading
      query={ESTATES_QUERY}
      variables={{
        searchQuery,
      }}
    >
      {({getData}) => {
        const estates = getData('viewer.broker.estateSearch.edges', []).map(edge => edge.node)
        return (
          <section>
            <EstateList
              estates={estates}
              showBroker={true}
            />
          </section>
        )
      }}
    </Query>
  )
}

SearchResult.propTypes = {
  searchQuery: PropTypes.string,
}

export default SearchResult
